import {makeStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import React from "react";
import PropTypes from "prop-types";
import AlertTriangle from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/interface-essential/alerts/alert-triangle.svg";
import AlertCircle from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/interface-essential/alerts/alert-circle.svg";
import CheckCircle1 from "@hapinest/theme/icons/streamlinehq/img/streamline-regular/interface-essential/form-validation/check-circle-1.svg";
import {CustomButton, StreamlineIcon} from "@hapinest/theme";

const useStyles = makeStyles((theme) => ({
    icon: {
        marginLeft: theme.spacing(2),
        display: "flex"
    },
    whiteColor: {
        color: theme.palette.secondary.contrastText,
    },
    message: {
        flex: 1,
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
    }
}));

const CustomSnackbarMessage = ({withIcon, type, message, buttonText, onButtonClick}) => {
    const classes = useStyles();

    const handleButtonClick = () => {
        if (onButtonClick) {
            onButtonClick();
        }
    };

    const renderIcon = () => {
        switch (type) {
            case "warning": return (
                <StreamlineIcon
                    className={classes.whiteColor}
                >
                    <AlertTriangle/>
                </StreamlineIcon>
            );
            case "warning2": return (
                <StreamlineIcon>
                    <AlertTriangle/>
                </StreamlineIcon>
            );
            case "info": return (
                <StreamlineIcon
                    className={classes.whiteColor}
                >
                    <AlertCircle/>
                </StreamlineIcon>
            );
            case "success": return (
                <StreamlineIcon
                    className={classes.whiteColor}
                >
                    <CheckCircle1/>
                </StreamlineIcon>
            );
            case "success2": return (
                <StreamlineIcon>
                    <CheckCircle1/>
                </StreamlineIcon>
            );
            default: return false;
        }
    };

    return (
        <Grid
            container
            justify={"center"}
            alignItems={"center"}
        >
            <Grid
                item
                className={classes.icon}
            >
                {withIcon && type !== "button" && renderIcon()}
            </Grid>

            <Grid
                item
                className={classes.message}
            >
                {React.isValidElement(message) ? (
                    React.cloneElement(message)
                ) : (
                    <Typography
                        variant="body1"
                        className={type !== "warning2" && type !== "success2" ? classes.whiteColor : undefined}
                    >
                        {message}
                    </Typography>
                )}
            </Grid>

            {buttonText && (
                <CustomButton
                    color={type === "info" ? "whiteText" : "primary"}
                    onClick={handleButtonClick}
                >
                    {buttonText}
                </CustomButton>
            )}
        </Grid>
    );
};

CustomSnackbarMessage.propTypes = {
    withIcon: PropTypes.bool,
    type: PropTypes.oneOf(["success", "success2", "info", "warning", "warning2", "button"]).isRequired,
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array]).isRequired,
    buttonText: PropTypes.string,
    onButtonClick: PropTypes.func
};

export default CustomSnackbarMessage;
